/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ProductListingHeader.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :
 *
 * @Date         : Oct 10, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : Added Version history. ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - Prduct Listing changes
 *
 * By            : H422336
 * On            : Sep 7 2020
 * Description   : ASDS-2748 - UI Enhancements as part of Phase II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Nov, 05 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II & Delete All MSA products
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
*******************************************************************************/
import React from 'react';
import { Grid } from '@scuf/common';
import SearchFilter from './SearchFilter';
import ProductsCategorySection from './ProductsCategory/ProductsCategorySection';
import ProductPriceUpdateNotification from '../Notifications/ProductPriceUpdateNotification';
import NonMSAPOProductsDeleteNotification from '../Notifications/NonMSAPOProductsDeleteNotification';
import { connect } from 'react-redux';
import { CheckoutUILabels } from '../constants/checkout-constants';
import CartDetailsActions from '../redux/actions/cart-details-actions';


const ReactToastify =  require('react-toastify');

function notify() {
    ReactToastify.toast(<ProductPriceUpdateNotification closeToast={false}/>);
}

function nonMSAPonotify() {
    ReactToastify.toast(<NonMSAPOProductsDeleteNotification closeToast={false} msgTitle={CheckoutUILabels.PRODUCT_PRICE_UPDATE} msgBody={CheckoutUILabels.PO_PRODUCT_DELETE_MSG} />);
}
function deleteAllMSAProductNotify(){
    ReactToastify.toast(<NonMSAPOProductsDeleteNotification  closeToast={false} msgTitle={CheckoutUILabels.PRODUCT_PRICE_UPDATE} msgBody={CheckoutUILabels.DELETE_ALL_MSA_PRODUCT} />);
}


/**
 * @author ASDS Team
 * @description Menu for Product listing.
 */
function ProductListingHeader(props) {
    if (props.hasPriceChanged) {
        notify();
    }
    if (props.deleteNonMSAPOSuccessFlag) {
        nonMSAPonotify();
    }
    if (props.deleteAllProductsSuccessFlag) {
        deleteAllMSAProductNotify();
        props.updatedeleteAllProductsSuccessFlag(false);
    }


    return (
        <Grid.Row>
            <Grid.Column width={12} className="fullwidthRow">
                <Grid>
                    <Grid.Row>
                    <Grid.Column width={4} sWidth={4} xsWidth={4} className="fullwidthRow">
                            <ProductsCategorySection />
                        </Grid.Column>
                        <Grid.Column width={4} className="fullwidthRow">
                            <h1 className="purchase-sw-h1-font">Product Listing</h1>
                        </Grid.Column>
                    {/* </Grid.Row>
                    <Grid.Row className="fullwidthRow"> */}

                        <Grid.Column width={4} sWidth={4} xsWidth={4} className="productSearchBox inputBoxWrapper ">
                            <SearchFilter />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Grid.Column>
            <Grid.Column className="toaster-container">
            {<ReactToastify.ToastContainer
                hideProgressBar={true}
                closeOnClick={false}
                closeButton={false}
                newestOnTop={true}
                position={props.notify}
                toastClassName={'toast-notification-wrap' + (props.notify === 'top-right' ? ' product-price' : '')}
            />}
            </Grid.Column>
        </Grid.Row>
    );
}

function mapStateToProps(state) {
    return {
        hasPriceChanged: state.cartDetails.hasPriceChanged,
        notify: state.cartDetails.notify,
        deleteNonMSAPOSuccessFlag: state.cartDetails.deleteNonMSAPOSuccessFlag,
        deleteAllProductsSuccessFlag: state.cartDetails.deleteAllProductsSuccessFlag
     };
}

export default connect(mapStateToProps, {updatedeleteAllProductsSuccessFlag: CartDetailsActions.updatedeleteAllProductsSuccessFlag  })(ProductListingHeader);
